export default __webpack_public_path__ + "static/media/Ishaan_Sharma_Resume.5de0b343.pdf";